import React from "react";
import styles from "./EditorBtnCss.module.css";

class EditorBtn extends React.PureComponent {
	render() {
		const { config, handleClick, title } = this.props;
		const cssClass = `${ config.cssClass } ${ styles.editorBtn } ${ styles.geSprite } ${ config.active && styles.btn_active }`;
		return ( <button
						title={ title || config.title }
						className={ cssClass }
						onClick={ handleClick }/>
		)
	}
}

export default EditorBtn;
